import React from 'react';
import { Routes, Route } from 'react-router-dom';

import './index.scss';

import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';

// Imports des 7 pages
import Home from './pages/Home/Home';
import QuiSuisJe from './pages/QuiSuisJe/QuiSuisJe';
import LaNeuropsychologie from './pages/LaNeuropsychologie/LaNeuropsychologie';
import BilanNeuropsychologique from './pages/BilanNeuropsychologique/BilanNeuropsychologique';
import Accompagnements from './pages/Accompagnements/Accompagnements';
import Psychotherapie from './pages/Psychotherapie/Psychotherapie';
import Tarifs from './pages/Tarifs/Tarifs';

function App() {
  return (
      <>
        <ScrollToTop />
        <div className="main-layout">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/qui-suis-je" element={<QuiSuisJe />} />
              <Route path="/la-neuropsychologie" element={<LaNeuropsychologie />} />
              <Route path="/bilan-neuropsychologique" element={<BilanNeuropsychologique />} />
              <Route path="/accompagnements" element={<Accompagnements />} />
              <Route path="/psychotherapie" element={<Psychotherapie />} />
              <Route path="/tarifs" element={<Tarifs />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </>
  );
}

export default App;